/* src/app/admin-dashboard/vm-machine/vm-machine.component.css */
.activeTab {
  background-color: var(--primary-color);
}
.config-spacing {
  padding-top: 20px;
  padding-bottom: 50px;
  margin: 0px;
}
.navbar1 {
  background-color: var(--subheader-color);
  height: 45px;
}
/*# sourceMappingURL=vm-machine.component.css.map */
